import router from "@/router";

import {
  requestMain,
  requestDirectorMain,
  requestEncode,
  requestDirectorObituary,
  requestFuneralObituary
} from "@/apis/common_api";

const state = {
  language: "ko",
  loadingState: false,
  deemdedState: false,
  spinnerLoading: false,
  modal: { open: false, title: "", content: "", option1: "", option2: "" },
  errorMessage: "잘못된 요청입니다.",
  // ============ Rules ============ //
  emailRules: [
    v => !!v || "이메일을 작성해주세요.",
    v => /.+@.+\..+/.test(v) || "이메일 형식으로 작성해주세요.",
    v => v.search(/\s/) === -1 || "공백을 제거해주세요!"
  ],
  nameRules: [
    v => !!v || "이름을 작성해주세요.",
    v => v.search(/\s/) === -1 || "공백을 제거해주세요!"
  ],
  passwordRules: [v => !!v || "비밀번호를 작성해주세요"],
  mainNoticeList: [],
  mainFaqList: [],
  mainBannerAdminList1: [],
  mainBannerAdminList2: [],
  obituaryCount: 0,
  obituaryReadCount: 0,
  adminType: localStorage.getItem("access_type"),
  headTitle: ""
};

const getters = {
  getAdminType(state) {
    return state.adminType;
  },

  languageInfo(state) {
    return state.language;
  },
  getloadingState(state) {
    return state.loadingState;
  },
  getMainNoticeList(state) {
    return state.mainNoticeList;
  },
  getMainFaqList(state) {
    return state.mainFaqList;
  },
  getMainBannerAdminList1(state) {
    return state.mainBannerAdminList1;
  },
  getMainBannerAdminList2(state) {
    return state.mainBannerAdminList2;
  },
  getObituaryCount(state) {
    return state.obituaryCount;
  },
  getObituaryReadCount(state) {
    return state.obituaryReadCount;
  },
  getDeemState(state) {
    return state.deemdedState;
  },
  getHeadTitle(state) {
    return state.headTitle;
  }
};

const mutations = {
  CLOSE_MODAL(state) {
    state.modal.open = false;
  },
  OPEN_MODAL(state, modalTexts) {
    state.loadingState = false;
    state.modal.title = modalTexts.title;
    state.modal.content = modalTexts.content;
    state.modal.option1 = modalTexts.option1;
    state.modal.option2 = modalTexts.option2 ? modalTexts.option2 : null;
    state.modal.open = true;
  },
  START_LOADING(state) {
    state.loadingState = true;
  },
  END_LOADING(state) {
    setTimeout(() => {
      state.loadingState = false;
    }, 1000);
  },
  START_DEEMED(state) {
    state.deemdedState = true;
  },
  END_DEEMED(state) {
    state.deemdedState = false;
  },
  PUSH_ERROR_PAGE(state) {
    state.errorMessage = "잘못된 요청입니다.";
    router.push("/error");
  },
  START_SPINNER(state) {
    state.spinnerLoading = true;
  },
  END_SPINNER(state) {
    state.spinnerLoading = false;
  },

  MAIN_INIT(state, data) {
    state.mainNoticeList = data.resultNoticeList;
    state.mainFaqList = data.resultFaqList;

    state.obituaryCount = data.obituaryCount;
    state.obituaryReadCount = data.obituaryReadCount;
  },
  SET_HEAD_TITLE(state, data) {
    state.headTitle = data;
  }
};

const actions = {
  // new
  async REQUEST_MAIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestMain(parameter);
      // const response = await requestDirectorMain(parameter);

      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
      }
      commit("MAIN_INIT", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_ENCODE({ commit }, parameter) {
    const param = {};
    try {
      commit("START_LOADING");
      const response = await requestEncode(parameter);
      if (
        response.data !== null &&
        response.data !== undefined &&
        response.data.result === "success"
      ) {
        param.str = response.data.encodeStr;
        param.result = true;
      } else {
        param.result = false;
        alert(response.data.message);
      }
      commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      commit("END_LOADING");
    }
    return param;
  },
  // 장례지도사가 부고장 만들 때 필요한 정보 불러오기
  async REQUEST_DIRECTOR_OBITUARY({ commit }) {
    try {
      commit("START_LOADING");

      const response = await requestDirectorObituary();
      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
      }

      commit("MUSIC_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // 장례식장에서 부고장 만들 때 필요한 정보 불러오기
  async REQUEST_FUNERAL_OBITUARY({ commit }) {
    try {
      commit("START_LOADING");

      const response = await requestFuneralObituary();
      const { data } = response;

      if (data?.result !== "success") {
        alert(data.message);
      }

      commit("MUSIC_LIST", data);
      commit("MORTUARY_LIST", data);
      commit("ENTER_ROOM_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
